import { useState } from "react";

const LoginForm = ({updateLogin}) => {
    const [password, setPassword] = useState('');
    const [btndisable, setBtndisable] = useState('');
    const [loginword, setLoginword] = useState('Login');

    return <div className="col-md-6 col-12 mx-auto mt-5">
    <div className="card p-3 mb-5">
        <div className="form-group">
        <label htmlFor="password">Enter Password to activate Dashy</label>
            <input type="password" className="form-control"
            onChange={(event => setPassword(event.target.value))}
            value={password} placeholder="Enter password" id="password"
            />
        </div>
        <button onClick={() => {
            setBtndisable(true);
            setLoginword('Checking password...');
            fetch('https://api.voicecoach.net/login', {method:'post', body: JSON.stringify({password: password}),
        headers: {'Content-Type':'application/json'}, credentials: 'include'})
            .then(res => { if(res.ok) {
                updateLogin(true);
            } else {
                setLoginword('Password');
                setPassword('');
                setBtndisable(false);
            document.getElementById('password').classList.add('is-invalid');
        }})
    }}
        className="btn btn-primary mt-3"
        disabled={btndisable}
        >
            {loginword}
        </button>
    </div>
</div>

}

export default LoginForm;